import "../plugins/templates";
import MapPlaces from "../maps/mapPlaces";

window.locationMap = {};

(function () {

    locationMap = new MapPlaces({
        renderMapsInfoBox: hbs.templates.locationMap[mapSettings.mapsInfoBox ? mapSettings.mapsInfoBox : 'mapsInfoBox'],
        defaultIcon: mapSettings.mapIcon,
        hoverIcon: mapSettings.mapIconHover
    });

    locationMap.initMap2 = function () {
        this.initMap();
        this.setPlaces(places);
        var map = this.getMap();
        if (mapSettings.zoomLevel > 0) {
            var listener = google.maps.event.addListener(map, "idle", function () {
                map.setZoom(mapSettings.zoomLevel);
                google.maps.event.removeListener(listener);
            });
        }
    };

})();
